<template>
  <div id="container" class="sbook_st_detail">
    <!-- Location START -->
    <Location :id="selfbook.id" />
    <!-- Location END -->

    <!-- 도서 기본 정보 -->
    <SelfbookDetailHead :selfbook="selfbook" />

    <!-- 도서 세부 정보 -->
    <div class="section fill">
      <div class="inner line">
        <div class="detail_book_introduce">
          <!-- Detail Box 품목 -->
          <BookDetailBox :book="selfbook" />

          <!-- Display Categories & Staged category dropdowns -->
          <BookCategoryBox
            :categories="getAllSelfbookCategories"
            :current-categories="selfbook.currentCategories"
          />
          <!-- TODO: @Stan need to fix TipTap so that it can format text in the textarea, rather than the TipTap box (or change the styles of the TipTop box to match) -->
          <TextareaBox
            :title="$t('views.selfbook.selfbookmodify.4224')"
            :text="selfbook.description"
          />

          <TextareaBox
            :title="$t('views.selfbook.selfbookmodify.2611')"
            :text="selfbook.contents"
          />
        </div>
      </div>
    </div>
    <!-- WIP -->
    <div class="sales_volume_wrap">
      <!-- Tabbed Section 1 -->

      <!-- Tabbed Section 2 -->
      <SalesChart :chart-data="chartData" />
      <!-- End TAB 2 -->
    </div>

    <!-- Review -->
    <ReviewBox :book="selfbook" />
  </div>
</template>

<script>
import TextareaBox from '@/components/library/TextareaBox.vue'
import ReviewBox from '@/components/library/ReviewBox'
import SalesChart from '@/components/selfbook/SalesChart'
import BookCategoryBox from '@/components/library/BookCategoryBox'
import SelfbookDetailHead from '@/components/selfbook/SelfbookDetailHead'
import Location from '@/components/selfbook/Location'
import BookDetailBox from '@/components/library/BookDetailBox'
import { mapGetters } from 'vuex'

export default {
  name: 'SelfbookModify',
  components: {
    BookDetailBox,
    BookCategoryBox,
    Location,
    SelfbookDetailHead,
    SalesChart,
    ReviewBox,
    TextareaBox
  },

  data() {
    return {
      showCategoriesEdit: false,
      showDescriptionEdit: false,
      showContentsEdit: false,
      selfbook: {
        currentCategories: [
          {
            title: 'CATEGORY TITLE',
            sub1: 'SUB 1',
            sub2: 'SUB 2'
          },
          {
            title: 'CATEGORY TITLE2',
            sub1: 'SUB 2.1',
            sub2: 'SUB 2.2'
          }
        ],
        id: '12345',
        title: '나의 셀프북',
        author: 'Tommy Knockers',
        publisher: 'Tommy Inc',
        rating: 3.5,
        reviewCount: 40,
        hasPaper: true,
        hasEbook: true,
        hasPod: false,
        color: 'orange',
        // Status can = 'editing', 'pending', 'selling', 'stopped', 'adminStopped'
        status: 'editing',
        price: '18000',
        date: '2018년 10월 30일',
        size: '242',
        pageCount: '272',
        description:
          '(500+ chars) Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean. A small river named Duden flows by their place and supplies it with the necessary regelialia. It is a paradisematic country, in which roasted parts of sentences fly into your mouth. Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic lift into the sky of great. A small river named Duden flows by their place and by and by it passed that the giant.',
        contents: '(Short text) Content text example',
        reasonStopped: '다른 사용자에게 유해한 내용이 포함되어 있어',
        complaints: {
          obscenity: 0,
          copyright: 5,
          repetitive: 1,
          other: 0
        }
      },
      dropdowns: [
        {
          id: 1
        },
        {
          id: 2
        },
        {
          id: 3
        }
      ],

      chartData: {
        monthlySales: [
          { date: '12.02.20', count: 5 },
          { date: '12.02.20', count: 5 }
        ],
        // TODO: Year filter should be calculated server side
        // This is just temp data
        // Available years should start at 2020 and go to current year
        years: [2020, 2021],
        filters: ['판매량', '판매금액'],
        salesCount: 123,
        salesPrice: 456
      }
    }
  },
  computed: {
    ...mapGetters(['getAllSelfbookCategories'])
  },
  methods: {
    editCategories() {
      this.showCategoriesEdit = true
    },
    editDescription() {
      this.showDescriptionEdit = true
    },
    editContents() {
      this.showContentsEdit = true
    }
  }
}
</script>

<style lang="scss" scoped></style>
